/*
 * @Description: 文件内容
 * @Author: dali
 * @Date: 2022-03-30 15:15:27
 * @LastEditors: dali
 * @LastEditTime: 2023-02-17 13:27:59
 */
import React, { Component } from 'react'
import styles from './expense.scss'
import Container from '@/components/container'
import FlexRowCon from '@/components/flexRowCon'
import SectionTitle from '@/components/sectionTitle'
import expenseLeftBg from '@/common/images/expense_bg_left.png'
import expenseRightBg from '@/common/images/expense_bg_right.png'
import { Button, Space, message } from 'antd'
import AppointmentForm from '@/components/appointment-form'
import UserForm from '@/components/userForm'
import User from '../../modules/user'
import { SYSCON } from '@/const/const'
import wrapWithUser from '@/components/wrapWithUser'

class Expense extends Component {
  constructor(props) {
    super(props)
    this.appointmentRef = React.createRef()
    this.userRef = React.createRef()
    this.allOrgHasBuy = ''
    this.btnType = ''
    this.productId = ''
    this.state = {
      freeTrialPerd: 0
    }
  }
  componentDidMount() {
    this.init()
  }
  wdStyles = {
    width: '80px',
    display: 'flex',
    justifyContent: 'center'
  }
  init = async() => {
    const user = new User()
    // 初始化

    await user.getProdList(SYSCON.PlatAppExpense).catch((err)=>{
      console.log('getProdListerr', err)
    })
    this.getFreePerd('标准版')
  }
  getNaviUrl = () => {
    const prodCd = SYSCON.PlatAppExpense
    return `${process.env.REACT_APP_PRODUCT_URL}&token=${localStorage.getItem(SYSCON.Token)}&appCatCd=${SYSCON.PlatAppWorkbench}&prodId=${this.productId}&prodCd=${prodCd}${this.allOrgHasBuy ? '&allOrgHasBuy=' + this.allOrgHasBuy : ''}`
  }
  showTip = (actionNm) => {
    const content = `您已试用或激活该产品，无法重复${actionNm}!`
    message.warning(content)
  }
  handleProduct = async(btnType) => {
    this.btnType = btnType
    const user = new User()
    /**
     * 1. 判断是否登录， 未登录的话，要先登录
     * 2. 判断用户是否有购买资格(普及版特殊，多一个字段smarterFinTradeEditionFlag)
     * 2.1 如果是购买操作 该用户“作为内部用户的任一根机构”已正式激活某个产品的情况下，依旧可以正常产品购买流程中进行该产品的购买，但必须创建另外一个根机构
     * 2.2 如果是试用操作 若该用户“作为内部用户的任一根机构”已试用或激活过对应“产品”则提示其不能重复试用
     * 3. 获取产品id
     * 4. 如果是普及版、组织过滤为个人组织， 如果是其他版本 组织过滤为企业组织
     * 5. 如果filter结果为0 直接跳转到产品层级选择界面
     * 6. 如果filter结果为1 带上组织信息 跳转产品层级选择界面
     * 7. 如果filter结果大于1 先选择组织 再跳转
     */
    if (!user.getLoginStatu()) {
      this.userRef.current.open()
      return
    }
    this.productId = await user.getProductId(SYSCON.PlatAppExpense)
    const userInfo = user.getUserInfo()
    const prodCd = SYSCON.PlatAppExpense
    // const smarterFinTradeEditionFlag = this.props.title === '普及版'
    user.checkPurchaseQualification(userInfo.id, prodCd, false)
      .then(checkRes => {
        // checkRes 是否通过检查
        if (this.btnType === 'try') {
          if (!checkRes) {
            this.showTip('试用')
            return
          }
        }
        if (this.btnType === 'buy') {
          if (!checkRes) {
            this.showTip('购买')
            return
          }
          this.allOrgHasBuy = checkRes ? '0' : '1'
        }
        window.location.href = (this.getNaviUrl())
      })
      .catch(err => {
        console.log('err', err)
      })
  }
  getFreePerd(title) {
    const prod = this.props.user.getExpendProdsByTitle(title)
    this.freeTrialPerd = (+(prod && prod.freeTrialPerd) || 0)
    this.setState({
      freeTrialPerd: (+(prod && prod.freeTrialPerd) || 0)
    })
  }
  handleAppointment(title) {
    this.appointmentRef.current.open(title, SYSCON.PlatAppExpense)
  }
  render() {
    return (
      <section id='expense'>
        <Container>
          <UserForm onRef={this.userRef} />
          <AppointmentForm onRef={this.appointmentRef}/>
          <FlexRowCon>
            <SectionTitle title={'报销管理'}/>
          </FlexRowCon>
          <div className={styles['img-container']}>
            <img src={expenseLeftBg} className={styles['bg-img']}/>
            <div className={styles['right-part']}>
              <div className={styles['desc-part']}>
                <p className={styles['desc-title']}>报销管理-标准版</p>
                <p>￥300/年起</p>
                <p>
                  适用于中小型企业的报销管理，可按不同报销类型分类管理，进项发票的扫描与录入，工作流在线审批。
                </p>
                <p>
                  与财务系统关联后，更可一键生成凭证，轻松管理企业账务。
                </p>
                {/* {(+this.state.freeTrialPerd > 0) && <p className={styles['sug-info']}>{'免费试用' + +this.state.freeTrialPerd + '个月'}</p> } */}
                <div className={styles['btns']}>
                  <Space size='large'>
                    {this.state.freeTrialPerd === 0 ? (<Button style={this.wdStyles} type='primary' onClick={()=>this.handleAppointment('标准版')}> 预约试用
                    </Button>) : (<Button type='primary' style={this.wdStyles} onClick={()=>this.handleProduct('try')}>
                      立即试用
                    </Button>)}
                    <Button style={this.wdStyles} type='primary' onClick={()=>this.handleProduct('buy')}>
                 购买
                    </Button>
                  </Space>
                </div>
              </div>
              <img src={expenseRightBg} className={styles['bg-img']}/>
            </div>
          </div>
        </Container>

      </section>
    )
  }
}

export default wrapWithUser(Expense)
